import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Field, Form } from 'react-final-form';
import { Button, InputDate, composeValidators, isNumberString, validateLength, validateRequiredField, formatDateFromDB, } from 'shared';
function NewApplicationFinderForm({ handleSubmit, searchButtonLabel = 'FIND MY APPLICATION', submitting, }) {
    const onSubmit = (values) => {
        const valuesToSubmit = {
            ssnLastFour: values.ssnLastFour,
            dateOfBirth: formatDateFromDB(values.dateOfBirth, true),
            zip: values.zip,
        };
        handleSubmit(valuesToSubmit);
    };
    const formatlast4 = (value) => {
        if (!value) {
            return '';
        }
        if (value.length > 4) {
            return value.slice(0, 4);
        }
        if (!isNumberString(value)) {
            return value.slice(0, value.length - 1);
        }
        return value;
    };
    const formatZip = (value) => {
        if (!value) {
            return '';
        }
        if (value.length >= 5) {
            return value.slice(0, 5);
        }
        if (!isNumberString(value)) {
            return value.slice(0, value.length - 1);
        }
        return value;
    };
    return (_jsx(_Fragment, { children: _jsx(Form, { onSubmit: onSubmit, render: ({ handleSubmit, hasValidationErrors, pristine }) => (_jsxs("form", { onSubmit: handleSubmit, children: [_jsx("div", { className: "input-container-single", children: _jsx(Field, { name: "ssnLastFour", validate: composeValidators(validateRequiredField, validateLength(4, 4, 'Wrong length (should be 4 digits)')), parse: formatlast4, type: "text", children: ({ input, meta }) => (_jsxs(_Fragment, { children: [_jsx("label", { htmlFor: "ssnLastFour", className: meta.error && meta.touched ? 'invalid' : '', children: "Last 4 of Social Security Number / Individual Taxpayer Identification Number*" }), _jsx("input", { ...input, className: meta.error && meta.touched ? 'invalid' : '', placeholder: "Last 4 of SSN / ITIN" }), meta.error && meta.touched ? (_jsx("span", { children: meta.error })) : (_jsx("span", {}))] })) }) }), _jsx("div", { className: "input-container-single", children: _jsx(InputDate, { fieldName: "dateOfBirth", dataTestId: "date-of-birth", fieldLabel: "Date of Birth" }) }), _jsx("div", { className: "input-container-single", children: _jsx(Field, { name: "zip", validate: composeValidators(validateRequiredField, validateLength(5, 5, 'Wrong length (should be 5 digits)')), parse: formatZip, type: "text", children: ({ input, meta }) => (_jsxs(_Fragment, { children: [_jsx("label", { htmlFor: "zip", className: meta.error && meta.touched ? 'invalid' : '', children: "Zip Code*" }), _jsx("input", { ...input, className: meta.error && meta.touched ? 'invalid' : '', placeholder: "Zip Code" }), meta.error && meta.touched ? (_jsx("span", { children: meta.error })) : (_jsx("span", {}))] })) }) }), _jsx(Button, { className: "button-warn", type: "submit", submitting: submitting, pristine: pristine || hasValidationErrors, children: searchButtonLabel })] })) }) }));
}
export default NewApplicationFinderForm;
